import { useCallback } from 'react';
import Script from 'next/script';

interface TrustpilotScriptProps {
  onLoad?: () => void;
  onError?: (error: Error) => void;
}

export function TrustpilotScript({ onLoad, onError }: TrustpilotScriptProps) {
  const handleLoad = useCallback(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  const handleError = useCallback(
    (error: Error) => {
      if (onError) onError(error);
    },
    [onError],
  );

  return (
    <Script
      type="text/javascript"
      src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      async
      onLoad={handleLoad}
      onError={handleError}
    />
  );
}

export default TrustpilotScript;
